import script from "./CategorySelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CategorySelect.vue?vue&type=script&setup=true&lang=js"

import "./CategorySelect.vue?vue&type=style&index=0&id=04242374&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04242374"]])

export default __exports__